/**
 * PayPal client utilities.
 */

/**
 * Refund a PayPal payment (call from admin or provider side).
 *
 * @param {string} captureId - PayPal capture ID (from tx protectedData.paypalCaptureId)
 * @param {number|null} amount - decimal amount to refund, or null for full refund
 * @param {string} currency
 */
export const refundPayPalPayment = async (captureId, amount = null, currency = 'EUR') => {
  const res = await fetch('/api/paypal/refund', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ captureId, amount, currency }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Refund failed');
  }
  return res.json();
};

/**
 * Extract PayPal data from a Sharetribe transaction's protectedData.
 */
export const getPayPalDataFromTransaction = (transaction) => {
  const pd = transaction?.attributes?.protectedData || {};
  return {
    orderId: pd.paypalOrderId || null,
    captureId: pd.paypalCaptureId || null,
    orderDetails: pd.orderDetails || null,
  };
};
